export const STORE_KEY = 'auth';

export const GO_LOGIN = 'auth/GO_LOGIN';
export const GO_LOGOUT = 'auth/GO_LOGOUT';
export const LOGGING_IN = 'auth/LOGGING_IN';
export const LOGGED_IN = 'auth/LOGGED_IN';
export const LOGGING_OUT = 'auth/LOGGING_OUT';
export const LOGGED_OUT = 'auth/LOGGED_OUT';
export const AUTH_ERROR = 'auth/ERROR';
export const RESET_AUTH_STATE = 'auth/RESET_STATE';

export const REFERRER_URL = 'auth/REFERRER_URL';

export const DEFAULT_USER = { };



// WEBPACK FOOTER //
// ./src/store/actions/auth.types.js